import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../shared/store/application-state';
import { NavigationQuery } from '../../store/navigation.reducer';
import { NavPopoverBase } from './nav-popover-base';
import { NavigationItem } from '../../models/navigationItem';

@Component({
	selector: 'bas-nav-icon',
	templateUrl: './nav-icon.component.html',
	styleUrls: ['./nav-icon.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class NavIconComponent extends NavPopoverBase {

	readonly altNavItem = input.required<NavigationItem>();
	readonly hasPopover = computed(() => this.altNavItem().children.length > 0);
	readonly popoverOpened = output<NavIconComponent>();

	private readonly store = inject(Store<ApplicationState>);
	private readonly basket = this.store.selectSignal(NavigationQuery.getBasket);
	readonly showBasketCount = computed(() => !!this.altNavItem().parameters?.['showBasketCount']);
	readonly basketCount = computed(() => this.showBasketCount() ? this.basket()?.shoppingcartsize ?? 0 : 0);
	readonly isBasketEmpty = computed(() => this.showBasketCount() && !this.basketCount());

	override onPopoverShow() {
		super.onPopoverShow();
		this.popoverOpened.emit(this);
	}

	override onClick($event: Event) {
		if (this.hasPopover()) {
			super.onClick($event);
		} else {
			this.navigate();
		}
	}

	navigate() {
		const navItem = this.altNavItem();
		this.router.navigate([navItem.url], { queryParams: navItem.query });
	}
}
